import type { IMessage, IMessageContext } from '@components/messages'
import { MessageContext } from '@components/messages'
import { useCallback, useContext } from 'react'

export type UseNotifierResult = IMessageContext

function useNotifier(): UseNotifierResult {
  const notificationContext = useContext(MessageContext)

  return useCallback(
    (options: IMessage) => {
      notificationContext?.show(options, options.autohide)
    },
    [notificationContext],
  )
}

export default useNotifier
